import { useSnackbar } from 'notistack';
import { checkValidContent } from './utilities';

interface ValidationParams {
  videoText: string;
  videoEffectPrompt: string;
  selectedAvatar: string | null;
  selectedAudio: string | null;
  videoName?: string;
  enqueueSnackbar: (message: string, options?: { variant: 'error' | 'success' }) => void;
}

export const validateCreateVideoInputs = ({
  videoText,
  videoEffectPrompt,
  selectedAvatar,
  selectedAudio,
  videoName,
  enqueueSnackbar,
}: ValidationParams) => {
  if (!videoText?.trim()?.length) {
    enqueueSnackbar('It looks like your script is empty. Please add content before submitting.', {
      variant: 'error',
    });
    return false;
  }
  if (videoEffectPrompt?.trim()?.length > 100) {
    enqueueSnackbar('Effect Prompt exceeds the maximum character limit of 100 characters.', { variant: 'error' });
    return false;
  }
  const isContentValid = checkValidContent(videoText);
  if (!isContentValid) {
    enqueueSnackbar('Please enter valid content', { variant: 'error' });
    return false;
  }

  // Only validate effect prompt if it's not empty
  if (videoEffectPrompt && videoEffectPrompt.trim().length > 0) {
    const isEffectPromptValid = checkValidContent(videoEffectPrompt);
    if (!isEffectPromptValid) {
      enqueueSnackbar('Please enter valid effect prompt', { variant: 'error' });
      return false;
    }
  }
  if (!selectedAvatar?.trim()) {
    enqueueSnackbar('Please select an avatar', { variant: 'error' });
    return false;
  }
  if (!selectedAudio?.trim()) {
    enqueueSnackbar('Please select an audio', { variant: 'error' });
    return false;
  }
  if (!videoName?.trim()) {
    enqueueSnackbar('Please enter video name', { variant: 'error' });
    return false;
  }

  return true;
};
